


(function() {
    var callback = function(mutationsList, observer) {

        var amount = 0;
        var current = 0;
        var messageElement = document.querySelector(".cart__message");

        if (messageElement) {
            amount = messageElement.getAttribute("data-limit");
            current = document.querySelector(".cart__total__money").innerText.replace(/[^0-9.-]+/g, "");

            var percent = (current / amount) * 100;
            if (percent > 100) {
                percent = 100;
            }

            var circleElement = document.querySelector(".cart__visual-circle");
            if (circleElement) {
                if (percent == 100 && !circleElement.classList.contains("completed")) {
                    circleElement.classList.add("completed");
                } else if (percent < 100 && circleElement.classList.contains("completed")) {
                    circleElement.classList.remove("completed");
                }
            }


            var domesticAmt = document.querySelector(".ship-unlockat .free-ship-amt");
            if (domesticAmt && domesticAmt.innerText != amount) {
                domesticAmt.innerText = amount;
            }

            var progressElement = document.querySelector(".cart__message-default-visual .cart__visual-lines .cart__visual-progress");
            if (progressElement) {
                progressElement.style.width = percent + "%";
            }

        }
    };
    callback();
    var observer = new MutationObserver(callback);
    observer.observe(document.querySelector(".cart__message"), { attributes: true, childList: true, subtree: true });

})();














